import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Image01 from "../../images/solution/startup/startup-girl.png";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Link} from 'gatsby';

const Startupapp = () => {
  return (
    <div className="startup_app p-100">
          <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="banenr_content">
                                <h1>Why Should You Get An App For Your Startup?</h1>
                            <p>Users spend 3 hours daily on mobile apps, and this percentage has increased over five years.</p>
                            <p>Today, most of your audience opts for mobile apps, and apps are considered a viable solution to engage customers, especially for startups.</p>
                            <p>By clarifying your vision and digitalizing your startup with a perfect app solution, you can disrupt your industry by connecting and engaging your brand with its audience by deploying a mobile application.</p>
                            <Link to="/contact"
                                  className="border_btn" aria-label="TekRevol Contact">Let’s Start Building an App Together</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto offset-xl-1">
                    <LazyLoadImage
                                        src={Image01}
                                        effect="blur" alt="Image01" className="img-fluid"
                                    />
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Startupapp 